import { Barcode, IBarcode } from '../..'
import { v4 as uuid } from 'uuid'

export interface IPriceListEntry {
  id: string
  upc: string
  description: string
  barcode?: IBarcode
  orderingNotes?: string
  category?: string
}

export class PriceListEntry implements IPriceListEntry {
  public id: string = uuid()
  public barcode?: Barcode
  public orderingNotes?: string
  public category?: string

  constructor(
      public upc: string,
      public description: string
  ) {}

  public get isBlank() {
    return !this.upc
      && !this.description
      && !this.barcode
      && !this.orderingNotes
      && !this.category
  }
}
